import type {
    MetricsFieldsBuilder,
    MetricsFieldsContext,
    MetricsFieldsProvider,
} from '@jet/engine';

export class PageContextFieldsProvider implements MetricsFieldsProvider {
    addMetricsFields(
        builder: MetricsFieldsBuilder,
        _context: MetricsFieldsContext,
    ) {
        // TODO: do metrics
        const pageContext = 'context';
        builder.addValue(pageContext, 'pageContext');
    }
}
